// import { Link } from "react-router-dom";
import { useHistory, withRouter } from "react-router";
import { Container, Col, Row } from "reactstrap";
import "./index.scss";

function Applicationfooter({ isLogin = false }) {
  const history = useHistory();
  return (
    <Container className="application-footer">
      <Row sm="12" md="12" lg="10" className="powered-by-container">
       <Col className="testPolicy" xs='6' sm="6" md="6" lg="6">
            <a style={{textDecoration: 'underline', color: 'blue'}} href="/privacyPolicy">Privacy Policy</a>
       </Col>
       <Col className="testPolicy" xs='6' sm="6" md="6" lg="6">
            <a style={{textDecoration: 'underline', color: 'blue'}} href="/deleteAccount">Deactivate/Delete account</a>
       </Col>
        <Col xs='7' sm="7" md="7" lg="7" className="logo-container">
          <span
            className={isLogin ? "logo-title  white-color-title" : "logo-title"}
          >
            Presented By
          </span>
          <img
            alt="reboot-logo"
            className="presented-by-logo"
            src={
              isLogin
                ? "https://reboot-s3-bucket.s3.amazonaws.com/logo-white.png"
                : "https://reboot-s3-bucket.s3.amazonaws.com/logo.png"
            }
          />
        </Col>
        <Col xs='4' sm="4" md="4" lg="4" className="logo-container">
          <span
            className={
              isLogin
                ? "logo-title add-exta-padding white-color-title"
                : "logo-title add-exta-padding"
            }
          >
            Powered By
          </span>
          <img
            src={
              isLogin
                ? "https://reboot-s3-bucket.s3.amazonaws.com/infojini-logo-white.svg"
                : "https://reboot-s3-bucket.s3.amazonaws.com/infojini-logo.svg"
            }
            alt="infojini-logo"
            className="reboot-logo-img"
          ></img>
        </Col>
      </Row>
      {/* <Col
        sm="4"
        md="4"
        lg="2"
        className="application-footer__button-container"
      >
        <Link
          to="/"
          className={
            isLogin
              ? "disclaimer-button-footer"
              : "disclaimer-button-footer blue-color-text"
          }
        >
          Disclaimer
        </Link>
      </Col> */}
    </Container>
  );
}

export default withRouter(Applicationfooter);
